import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import _ from "lodash"
import axios from "axios"
import settings from "settings"
import { loadingStatus, getPayload } from "actions"
import DocumentModal from "containers/modals/document"
import Modal from "react-responsive-modal"
import moment from "moment"
import { toast } from "react-toastify"
import FullTable from "components/FullTable"
import Switch from "react-switch"
import helpers from "helpers/helpers"

class DocumentManagement extends Component {
	constructor(props) {
		super(props)

		this.state = {
			data: [],
			docs: [],
			modal: false,
			alertError: false,
			alertSuccess: false,
			filtered: [],
			alertTitle: "",
			alertText: "",
			columns: [
				{
					Header: "Community",
					accessor: "community",
					filterMethod: (f, r) => helpers.tableText(f, r, "community"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Salesperson",
					accessor: "salesperson",
					filterMethod: (f, r) => helpers.tableText(f, r, "salesperson"),
				},
				{
					Header: "Submitted Date",
					accessor: "date",
				},
				{
					Header: "Address",
					accessor: "address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				{
					Header: "",
					accessor: "edit",
				},
			],
			defaultSorted: [],
			paperworkAll: false,
			modalStatus: false,
			modalData: "",
		}
	}

	componentDidMount() {
		this.props.loadingStatus(true)
		this.getDocuments()
	}

	getDocuments = () => {
		//console.log('%c' + `Getting Documents..`, 'background: #222; color: #bada55')
		var userToken = localStorage.getItem("user")
		axios
			.post(
				settings.ep + "/getDocuments",
				{},
				{
					headers: { Authorization: `Bearer ${userToken}` },
				}
			)
			.then((response) => {
				this.setState({ docs: response.data }, () => {
					this.props.loadingStatus(false)
				})
			})
			.catch((error) => {
				console.log(error)
				this.props.loadingStatus(false)
			})
	}

	buildTable() {
		let data = []
		//console.log(this.state.docs)
		let filtered = _.filter(this.state.docs, (r) => {
			if (this.props.activeProperties.includes(r.property)) {
				return true
			}
		})
		_.forEach(filtered, (v, k) => {
			let ret = {}
			let com = _.find(this.props.payload.public.properties, { id: v.property })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let lt = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if(lt) ret.lot_type = lt.name
			let salesperson = _.find(this.props.payload.public.salespeople, { id: v.salesperson })
			if (builder) {
				ret.builder = builder.name
			}
			if (com) {
				ret.community = com.name
			}
			if (salesperson) {
				ret.salesperson = `${salesperson.first} ${salesperson.last}`
			}
			ret.address = v.address
			// find the latest submit date on a document
			let date = 0
			_.forEach(v.documents, (row) => {
				if (row.uploaded_date > date) {
					date = row.uploaded_date
				}
			})
			ret.date = date ? moment.unix(date).format("MM/DD/YY") : ""

			ret.edit = (
				<a
					onClick={() => {
						this.setState({ data: v, modal: true })
					}}>
					View Documents
				</a>
			)
			data.push(ret)
		})
		return data
	}

	excelClean = (data) => {
		// This goes through and find all the react buttons in the table rows and turns them simply into "rejected".  rejected is the only react button, so we can get away with easy transformation.
		let ret = []
		_.forEach(data, (v,ind) => {
			_.forEach(v._original, (r, k) => {
				if (r && typeof r === "object") {
					data[ind]._original[k] = "Rejected"
				}
			})
			ret.push(v)
		})
		//console.log(ret)
		return ret
	}

	buildColumns() {
		let rows = this.buildTable()
		let assignedDocs = []
		_.forEach(this.props.activeProperties, (v) => {
			try {
				let property = _.find(this.props.payload.public.properties, { id: v })
				if (!property) throw new Error("Cannot find property")
				_.forEach(property.assigned_docs, (v) => {
					assignedDocs.push(v)
				})
			} catch (e) {
				console.log(e)
			}
		})
		assignedDocs = _.uniq(assignedDocs)
		let docColumns = _.map(assignedDocs, (v) => {
			try {
				let doc = _.find(this.props.payload.public.options.docs, { id: v })
				if (!doc) throw new Error("Cannot find doc.")
				return {
					Header: doc.name,
					accessor: doc.dbName,
					filterable: false,
					Cell: (props) => {
						if (typeof props.value == "number") {
							return moment.unix(props.value).format("MM/DD/YY")
						} else if (props.value) {
							return props.value
						} else return ""
					},
				}
			} catch (e) {
				console.log(e)
			}
		})
		const columns = [
			{
				Header: "Community",
				accessor: "community",
				filterMethod: (f, r) => helpers.tableText(f, r, "community"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: "Lot Type",
				accessor: "lot_type",
				filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
			},
			{
				Header: "Salesperson",
				accessor: "salesperson",
				filterMethod: (f, r) => helpers.tableText(f, r, "salesperson"),
			},
			{
				Header: "Neighborhood",
				accessor: "neighborhood",
				filterMethod: (f, r) => helpers.tableText(f, r, "neighborhood"),
			},
			{
				Header: "Section",
				accessor: "section",
				//width: this.getColumnWidth(rows, "section", "Section"),
				filterMethod: (f, r) => helpers.tableText(f, r, "section"),
			},
			{
				Header: "Block",
				accessor: "block",
				//width: this.getColumnWidth(rows, "block", "Block"),
				filterMethod: (f, r) => helpers.tableText(f, r, "block"),
			},
			{
				Header: "Lot",
				accessor: "lot",
				//width: this.getColumnWidth(rows, "lot", "Lot"),
				filterMethod: (f, r) => helpers.tableText(f, r, "lot"),
			},
			{
				Header: "Address",
				accessor: "address",
				filterMethod: (f, r) => helpers.tableText(f, r, "address"),
			},
			{
				Header: "Buyer Last",
				accessor: "buyer_last",
				filterMethod: (f, r) => helpers.tableText(f, r, "buyer_last"),
			},
			{
				Header: "Contract Date",
				accessor: "sale_date",
				filterable: false,
				Cell: (props) => (props.value ? moment.unix(props.value).format("MM/DD/YY") : ""),
				maxWidth: 125,
			},
			{
				Header: "Closing Date",
				accessor: "closing_date",
				filterable: false,
				Cell: (props) => (props.value ? moment.unix(props.value).format("MM/DD/YY") : ""),
				maxWidth: 125,
			},
			{
				Header: "Buyer Profile",
				accessor: "profile",
				filterable: false,
				Cell: (props) => (props.value && props.value > 0 ? moment.unix(props.value).format("MM/DD/YY") : ""),
				maxWidth: 125,
			},
			...docColumns,
		]

		return columns
	}

	closeModal() {
		this.setState({ modal: false })
	}

	buildPaperworkTable = () => {
		let f = []
		_.forEach(this.props.payload.exec.sales, (r) => {
			if (
				!this.props.activeProperties.includes(r.property) ||
				!r.documents ||
				r.bustout_date ||
				r.transfer_date
			) {
				return
			}
			let lot = _.find(this.props.payload.exec.lots, { id: r.lot_id })
			let sp = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
			let sec = _.find(this.props.payload.public.sections, { id: r.section_id })
			let builder = _.find(this.props.payload.public.builders, { id: r.builder })
			let lt = _.find(this.props.payload.public.lot_types, { id: r.lot_type })
			let neigh = _.find(this.props.payload.public.neighborhoods, { id: lot?.neighborhood })
			let section = sec ? sec.name : ""
			let community = _.find(this.props.payload.public.properties, { id: r.property })
			let ret = {
				section: section,
				neighborhood: neigh ? neigh.name : "",
				block: r.block,
				lot: r.lot,
				builder: builder ? builder.name : '',
				lot_type: lt ? lt.name : '',
				address: r.address,
				buyer_last: r.primary_last,
				//buyer_first: r.primary_first,
				sale_date: r.sale_date,
				closing_date: r.closing_date,
				community: community && community.name,
				documents: r.documents,
				salesperson: sp ? `${sp.first} ${sp.last}` : "",
			}
			let status = true // meaning all good

			_.forEach(r.documents, (v) => {
				let doc = _.find(this.props.payload.public.options.docs, { dbName: v.type })
				if (v.status == "accepted") {
					ret[v.type] = v.approved_date
				} else if (v.status == "rejected") {
					status = false
					ret[v.type] = (
						<>
							<span className="hide">Rejected</span>
							<button
								className="btn red"
								onClick={() => {
									this.setState({
										modalStatus: true,
										modalData: (
											<>
												<h1>Paperwork Rejection</h1>
												<table className="rejectionTable">
													<tbody>
														<tr>
															<td>Address</td>
															<td>{r.address}</td>
														</tr>
														<tr>
															<td>Document</td>
															<td>{doc.name}</td>
														</tr>
														<tr>
															<td>Reason</td>
															<td>{v.reason}</td>
														</tr>
													</tbody>
												</table>
											</>
										),
									})
								}}>
								Rejected
							</button>
						</>
					)
				} else if (v.status == "awaiting" || v.status == "pending") {
					status = false
				}
			})

			// If the row is status = true, and it's past 1 week, do not add.
			if (status && r.closing_date) {
				let week = moment().subtract(1, "week").unix()
				if (r.closing_date < week) {
					return
				}
			}
			if (this.state.paperworkAll) {
				f.push(ret)
			} else {
				if (!status) f.push(ret)
			}
		})
		return f
	}

	alert = (obj) => {
		if (obj.status) {
			toast.success(obj.text)
			this.setState({ modal: false })
			this.getDocuments()
		} else {
			toast.error(obj.text)
			this.setState({ modal: false })
			this.getDocuments()
		}
	}

	getTrProps = (state, rowInfo, instance) => {
		if (rowInfo) {
			let v = rowInfo.original
			let className = ""
			if (v.documents && v.documents.length > 0) {
				let rejects = _.find(v.documents, { status: "rejected" })
				let awaiting = _.find(v.documents, { status: "awaiting" })
				let pending = _.find(v.documents, { status: "pending" })
				let allApproved = false
				if (!pending && !awaiting && !rejects) {
					allApproved = true
					_.forEach(v.documents, (r) => {
						if (r.status !== "accepted") {
							allApproved = false
						}
					})
				}
				// Order matters here
				// Pending is above awaiting simply due to the fact that some people submit combined documents
				if (rejects) {
					className = "statusColor--rejected"
				} else if (pending) {
					className = "statusColor--pending"
				} else if (awaiting) {
					className = "statusColor--awaiting"
				} else if (allApproved) {
					className = "statusColor--approved"
				}
			} else if (!v.documents && v.sale_date) {
				className = "statusColor--awaiting"
			}
			return {
				className: className,
			}
		}
		return {}
	}

	toggle = () => {
		this.setState({ paperworkAll: !this.state.paperworkAll })
	}

	render() {
		if (this.props.payloadStatus) {
			return (
				<div className="documents">
					<Title title="Document Management" showDate={false} />
					<div className="content">
						<FullTable
							data={this.buildTable()}
							columns={this.state.columns}
							classNames={"small"}
							name="documemtManagement__documents"
							title="Documents"
							unset={["documents", "edit"]}
							pageSize={20}
						/>
						<div>
							<h2>Paperwork</h2>
							<div className="switch" style={{ marginTop: 15 }} onClick={(e) => e.stopPropagation()}>
								<Switch
									onChange={() => this.toggle()}
									checked={this.state.paperworkAll}
									checkedIcon={false}
									uncheckedIcon={false}
									key={"switch"}
									id={"switch"}
								/>
								<p>Showing {this.state.paperworkAll ? "All" : "Missing"}</p>
							</div>
							<ul className="legend__list" style={{ paddingLeft: 0 }}>
								<li>
									<span className="statusColor--awaiting" /> Awaiting Paperwork
								</li>
								<li>
									<span className="statusColor--pending" /> Pending Approval
								</li>
								<li>
									<span className="statusColor--rejected" /> Rejection
								</li>
								<li>
									<span className="statusColor--approved" /> Approved Paperwork
								</li>
							</ul>
							<FullTable
								data={this.buildPaperworkTable()}
								columns={this.buildColumns()}
								classNames={"small"}
								name="documemtManagement__paperwork"
								title="Paperwork"
								unset={["documents"]}
								excelClean={this.excelClean}
								getTrProps={this.getTrProps}
								pageSize={20}
							/>
						</div>
						<DocumentModal
							open={this.state.modal}
							data={this.state.data}
							getDocs={this.getDocuments}
							alert={this.alert}
							loadingText=""
							onClose={(d) => {
								this.closeModal(d)
							}}
						/>
						<Modal
							classNames={{ modal: "modalForm" }}
							open={this.state.modalStatus}
							onClose={() => this.setState({ modalStatus: false })}
							center>
							{this.state.modalData}
						</Modal>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(DocumentManagement)
